import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {APP_CONFIG, UI_CONFIG } from '../config/app.config';

import logoImage from '../assets/images/app-logo.png';
import { useLang } from "../contexts/LangContext";


interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const { t } = useLang();

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, UI_CONFIG.SPLASH_DURATION / 10);

    // Complete splash screen after duration
    const timer = setTimeout(() => {
      onComplete();
    }, UI_CONFIG.SPLASH_DURATION);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [onComplete]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-gradient-to-br from-blue-500 to-blue-700 flex flex-col items-center justify-center z-50"
    >
      {/* Logo */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="mb-8"
      >
        <img
          src={logoImage}
          alt={t("appTitle")}
          className="w-32 h-32 object-contain"
        />
      </motion.div>

      {/* App Name */}
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="text-center mb-12"
      >
        <h1 className="app-header text-4xl font-bold text-white mb-2">{APP_CONFIG.NAME}</h1>
        {/* <p className="text-blue-100 text-lg">Fish Consumption Tracker</p> */}
      </motion.div>

      {/* Loading Progress */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="w-64"
      >
        {/* Progress Bar */}
        <div className="bg-blue-400/30 rounded-full h-2 overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.2 }}
            className="bg-white h-full rounded-full"
          />
        </div>

        {/* Loading Text */}
        <p className="text-blue-100 text-sm text-center mt-4">Loading...</p>
      </motion.div>

      {/* Version */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-8 text-blue-200 text-sm"
      >
        Version 1.0.0
      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;
